import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer_Logo from '../Assets/Images/logo.png';
import { title } from "../config/Config";

const Footer_main = () => {

  return (
    <>
    <div className="footer_sec">
        <Container>
          <Row className="align-items-start">

            {/* Logo Section */}
            <Col lg={3} md={6} xs={12}>
              <div className="footer_logo">
                <img src={Footer_Logo} alt="logo" />

                <div className="social_icons">
                  <i className="bi bi-facebook"></i>
                  <i className="bi bi-instagram"></i>
                  <i className="bi bi-youtube"></i>
                </div>
              </div>
            </Col>

            {/* Quick Links */}
            <Col lg={3} md={6} xs={12}>
              <div className="footer_links">
                <h5>Quick Links</h5>
                <ul>
                  <li>Home</li>
                  <li>Products</li>
                  <li>About Us</li>
                  <li>Contact Us</li>
                </ul>
              </div>
            </Col>

            {/* Policies */}
            <Col lg={3} md={6} xs={12}>
              <div className="footer_links">
                <h5>Quick Links</h5>
                <ul>
                  <li>Terms and Conditions</li>
                  <li>Privacy Policy</li>
                  <li>Shipping Policy</li>
                  <li>Returns & Exchanges</li>
                </ul>
              </div>
            </Col>

            {/* Contact */}
            <Col lg={3} md={6} xs={12}>
              <div className="footer_contact">
                <h5>Contact Us</h5>

                <p>
                  <i className="bi bi-geo-alt-fill"></i>
                  Nankiana Sahib Rd, Mubarik Mehal Colony, Sangrur, Punjab 148001
                </p>

                <p>
                  <i className="bi bi-envelope-fill"></i>
                  thenaturalayurveda@gmail.com
                </p>

                <p>
                  <i className="bi bi-telephone-fill"></i>
                  +91 98883 09794
                </p>
              </div>
            </Col>

          </Row>
        </Container>
      </div>

      {/* Bottom */}
      <div className="footer_bottom">
        <Container>
          <p>
            © 2026, {title} Designed & Developed By{" "}
            <span>Netcrafty</span>.
          </p>
        </Container>
      </div>
    </>
  );
};

export default Footer_main;
